module.exports = __webpack_public_path__ + "ad1a8f76c598862b1c68b3a789368768.png";